<template>
  <div
    class="layer_section type-wide-a"
    :class="displayModal ? 'showing' : ''"
  >
    <div class="layer_section-container shipping_delivery_st02">

      <personal-info
        v-if="termsId === 1"
      />

      <toss-personal-info
        v-if="termsId === 2"
      />

      <toss-banking
        v-if="termsId === 3"
      />

      <transfer-personal-info
        v-if="termsId === 4"
      />

      <apay-agreement
        v-if="termsId === 5"
      />

      <div class="align-box size-auto">
        <button
          type="button"
          class="btn-modal_close"
          @click="$emit('close-terms', true)"
        >
          확인
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import PersonalInfo from "@/views/order/main/components/TermsPopupContents/PersonalInfo";
import TossPersonalInfo from "@/views/order/main/components/TermsPopupContents/TossPersonalInfo";
import TossBanking from "@/views/order/main/components/TermsPopupContents/TossBanking";
import ApayAgreement from "@/views/order/main/components/TermsPopupContents/ApayAgreement";
import TransferPersonalInfo from "@/views/order/main/components/TermsPopupContents/TransferPersonalInfo";


export default {
  name: "PopupTerms",
  components: {
    PersonalInfo,
    TossPersonalInfo,
    TossBanking,
    ApayAgreement,
    TransferPersonalInfo
  },
  props: {
    displayModal: {
      type: Boolean,
      default: false,
    },
    termsId: {
      type: Number,
      required: true,
    },
  }
}
</script>

<style scoped>

</style>
